'use client';

import { useEffect, type ReactNode } from 'react';

// Utils
import { combineClasses } from '@shared/utils';

// Components
import { SplashSection } from '@/components/SplashSection';
import { MainHeader } from '@/ui/Landing/layout/Header';

// Animations
import { initSplashSection, initHeroCanvas } from '../../animations';

// Constants
import { IMAGES } from '@shared/constants';
interface AuthLayoutProps {
  className?: string;
  children?: ReactNode;
}
const LandingLayout = ({
  className,
  children
}: AuthLayoutProps) => {
  useEffect(() => {
    initSplashSection();
    const cleanupCanvas = initHeroCanvas();
    return () => {
      cleanupCanvas();
    };
  }, []);
  return <div className="font-poppins flex flex-col h-screen auth-layout-body is-loading" style={{
    backgroundColor: 'var(--auth-bg-base-color)'
  }} data-loading="true" data-sentry-component="LandingLayout" data-sentry-source-file="index.tsx">
      <SplashSection data-sentry-element="SplashSection" data-sentry-source-file="index.tsx" />

      <div id="page-content" hidden>
        <MainHeader data-sentry-element="MainHeader" data-sentry-source-file="index.tsx" />

        {/* Main */}
        <main className={combineClasses('flex-1 z-0 auth-constellation-bg', className)}>
          {/* Pre-rendered background image (replaces CSS gradient layers) */}
          <picture className="auth-bg-image pointer-events-none" data-sentry-element="picture" data-sentry-source-file="index.tsx">
            <source media="(max-width: 768px)" srcSet={IMAGES.LANDING_BG} />
            <img src={IMAGES.LANDING_BG} alt="landing background" aria-hidden="true" className="auth-bg-image-inner" fetchPriority="high" decoding="async" />
          </picture>
          {/* Canvas animation background */}
          <canvas id="hero-canvas" className="auth-bg-canvas pointer-events-none absolute inset-0 h-full w-full"></canvas>
          <div className="auth-bg-stars" aria-hidden="true"></div>
          <div className="relative auth-layout-viewport mx-auto w-full max-w-home-layout overflow-hidden pb-0">
            {/* Flex column: inner content + reserved bottom inset (see styles.css) */}
            <div className="auth-layout-viewport-inner">
              <div className="auth-layout-viewport-body">{children}</div>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default LandingLayout;